import { DateDayKey, DateMonthKey } from "../../types/customization/template";

export const monthArray: DateMonthKey[] = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const daysArray: DateDayKey[] = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export interface MonthsList {
  year: number;
  month: DateMonthKey;
  days: DayDetails[];
}

interface DayDetails {
  active: boolean;
  date: number;
  weekDay: number;
}

export function getDatesListFromDate(
  startingDate: string,
  monthCount = 12,
  withDays = true
): MonthsList[] {
  const firstDate = new Date(startingDate);

  const resultArray: MonthsList[] = [getMonthsDetailsFromDate(firstDate, withDays)];
  for (let i = 0; i < monthCount - 1; i++) {
    firstDate.setMonth(firstDate.getMonth() + 1);
    resultArray.push(getMonthsDetailsFromDate(firstDate, withDays));
  }

  return resultArray;
}

function getMonthsDetailsFromDate(month: Date, withDays: boolean): MonthsList {
  const currentYear = month.getFullYear();
  const currentMonth = month.getMonth();

  return {
    year: currentYear,
    month: monthArray[currentMonth],
    days: withDays ? getDaysForMonth(month.toString()) : [],
  };
}

function getDaysForMonth(date: string): DayDetails[] {
  const month = new Date(date);
  const currentMonth = month.getMonth();
  const days: DayDetails[] = [];
  const lastDayDate = new Date(date);
  lastDayDate.setMonth(lastDayDate.getMonth() + 1);
  lastDayDate.setDate(0);

  const firstDay = month.getDay();
  const diffFromFirstDayToDisplay = firstDay > 1 ? 2 - firstDay : firstDay === 0 ? -5 : firstDay;
  month.setDate(diffFromFirstDayToDisplay);
  days.push({
    active: currentMonth === month.getMonth(),
    date: month.getDate(),
    weekDay: month.getDay(),
  });

  while (month.getDay() !== 0 || month < lastDayDate) {
    month.setDate(month.getDate() + 1);
    days.push({
      active: currentMonth === month.getMonth(),
      date: month.getDate(),
      weekDay: month.getDay(),
    });
  }

  return days;
}
